import { rootApi } from '../rootApi';

export const productGroupApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getProductGroups: builder.query({
            query: () => ({
                url: 'v1/exportedcars/productgroups',
                method: 'GET'
            })
        })
    })
});

export const { useGetProductGroupsQuery } = productGroupApi;
